import "./CollectionItem.scss";

export default {
  props: {
    data: Object,
    isPlaceholder: Boolean,
  },
  methods: {
    goTo() {
      this.$router.push(
        `/${this.$store.state.company}/collection/expanded/${this.data.id}`
      );
    },

    setChecked() {
      this.$refs.itemCheckbox.checked = !this.$refs.itemCheckbox.checked;

      if (this.data.isTransfering && this.$refs.itemCheckbox.checked) {
        //is transfering and checked so set the selected collection values
        this.$store.state.transferItems = {
          selectedFiles: [],
          selectedFolders: [],
          collection: { ...this.data },
        };
      }
    },
  },
};
